module.exports = __webpack_public_path__ + "img/gal-9.258bb817.jpg";